import React from 'react';
import VersionHistorySection from 'components/v2/compiler/version-history/VersionHistorySection';
import DynamicContentRenderer from '../DynamicContentRenderer';
import { VersionLogFieldPanelRecord } from '../records/VersionLogFieldPanelRecord';

const FieldPanelRenderer: React.FC<VersionLogFieldPanelRecord> = ({ panelHeader, children }) => {
  if (!Array.isArray(children)) {
    return null;
  }
  return (
    <VersionHistorySection title={panelHeader}>
      <DynamicContentRenderer schema={children} />
    </VersionHistorySection>
  );
};

export default FieldPanelRenderer;
